import {discardSettingsChangesModalAtom, settingsDirtyAtom, settingsModalAtom} from "@/store/jotaiAtoms";
import type {TSettingsModalState} from "@/store/types";
import {useAtomValue, useSetAtom} from "jotai";
import {useEffect} from "react";

export const useSettingsNavigation = () => {
  const isDirty = useAtomValue(settingsDirtyAtom);
  const askToDiscardChanges = useSetAtom(discardSettingsChangesModalAtom);
  const setSettingsModal = useSetAtom(settingsModalAtom);

  return (target: TSettingsModalState | null) => (isDirty ? askToDiscardChanges({target}) : setSettingsModal(target));
};

export const useSettingsDirty = (isDirty: boolean) => {
  const setDirty = useSetAtom(settingsDirtyAtom);

  useEffect(() => {
    setDirty(isDirty);
    return () => setDirty(false);
  }, [isDirty]);
};
